export class DailyRateInsuranceFeeDto {
    static instanceOf(obj) {
        return (typeof obj === 'object' &&
            obj !== null &&
            'dailyRate' in obj &&
            typeof obj.dailyRate === 'number' &&
            Object.keys(obj).length === 1);
    }
}
